import type * as React from "react";
import TelegramNotificationSection from "src/components/telegram-notification-section/telegram-notification-section";

const NotificationsPage: React.FC = () => {
	return (
		<div className="space-y-6 p-4 sm:p-6">
			<h1 className="sr-only">Notifications</h1>

			<div className="flex items-center gap-3">
				<span aria-hidden className="h-5 w-[3px] rounded-full bg-primary" />
				<p className="text-[11px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
					Notifications · Route order, payment, and withdrawal events to
					Telegram
				</p>
			</div>

			<TelegramNotificationSection />
		</div>
	);
};

export default NotificationsPage;
